<div class="gl-page">
  <yds-button-back text="Ga terug 'Downloadlijst vorige grootboek exporten'" (back)="onBack()" />

  <div class="gl-page__header">
    <h1 class="gl-page__title">Log journal processing</h1>
  </div>

  @if (isLoading()) {
    <yds-card>
      <div class="gl-list-state">
        <yds-spinner [label]="'Verwerkingslog laden...'" />
      </div>
    </yds-card>
  } @else if (loadError()) {
    <yds-empty-states [variant]="'error'" [message]="loadError() ?? ''" />
  } @else {
    <yds-card>
      <h2 header>Details</h2>

      @if (logs().length === 0) {
        <yds-empty-states [message]="'Er zijn geen logregels'" />
      } @else {
        <div class="gl-list-table">
          <yds-table
            [embedded]="true"
            [showPaginationFooter]="true"
            [resizable]="true"
            [columns]="tableColumns"
            [items]="tableItems()"
            [zebra]="true"
            [dottedColumns]="true"
          >
            <yds-pagination
              pagination
              [(pageIndex)]="pageIndex"
              [pageSize]="pageSize"
              [totalItems]="logs().length"
            />
          </yds-table>
        </div>
      }
    </yds-card>
  }
</div>
